<template>
    <div class="row">
        <div class="col-12 col-xl-12 col-xxl-12">
            <h1>{{$t('account_info.header_main')}}</h1>
            <loader v-bind="fetch">
                <transition :name="transitionName" mode="out-in">
                    <router-view/>
                </transition>
            </loader>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import {FETCH_ACCOUNT_DETAILS} from '../store/modules/account_details';
    import Loader from '../components/general/Loader';

    @Component({
        components: {Loader}
    })
    export default class Account extends Vue {
        fetch = {
            loading: false,
            error: false
        };

        created() {
            this.fetch.loading = true;
            this.fetch.error = false;
            this.$store.dispatch(FETCH_ACCOUNT_DETAILS)
                .catch(error => {
                    this.fetch.error = this.$t('common.notify_fetch_failure');
                    this.$notify.error(this.fetch.error);
                })
                .finally(() => this.fetch.loading = false);
        }

        transitionName = '';
        beforeRouteUpdate(to, from, next) {
            const isSubPage = (to.path.includes(from.path));
            this.transitionName = isSubPage ? '' : '';
            // this.transitionName = isSubPage ? 'slide-left' : 'slide-right';
            next();
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Account.vue